import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Accessibility from '../screens/Accessibility';
import AwsPage from '../screens/AwsPage';
import BusinessOutcomeHCLS from '../screens/BusinessOutcomeHCLS';
import CaliforniaDataCollection from '../screens/CaliforniaDataCollection';
import CaseStudyMtomicsClinical from '../screens/CaseStudyMtomicsClinical';
import CaseStudyNonprofitConnect from '../screens/CaseStudyNonprofitConnect';
import CollaborateWithUs from '../screens/CollaborateWithUs';
import CookiePolicy from '../screens/CookiePolicy';
import DiscussProject from '../screens/DiscussProject';
import EarlyAccessProgram from '../screens/EarlyAccessProgram';
import EBooksPage from '../screens/EBooksPage';
import FinanceFirstCloudManagement from '../screens/FinanceFirstCloudManagement';
import GenAIAssessment from '../screens/GenAIAssessment';
import GenAINonProfit from '../screens/GenAINonProfit';
import HomePage from '../screens/HomePage';
import HubLifeNonprofitsSolutionGuide from '../screens/HubLifeNonprofitsSolutionGuide';
import JoinConsultant from '../screens/JoinConsultant';
import JoinIntegrator from '../screens/JoinIntegrator';
import LetsCollaborate from '../screens/LetsCollaborate';
import MilestoneCirclesUpdate from '../screens/MilestoneCirclesUpdate';
import NotFound from '../screens/NotFound';
import PhoenixUserGroupUpdate from '../screens/PhoenixUserGroupUpdate';
import PrivacyPolicy from '../screens/PrivacyPolicy';
import RDSSQLServerArticle from '../screens/RDSSQLServerArticle';
import RisingRoutesCaseStudy from '../screens/RisingRoutesCaseStudy';
import ServerError from '../screens/ServerError';
import SignIn from '../screens/SignIn';
import Subscribe from '../screens/Subscribe';
import TermsOfUse from '../screens/TermsOfUse';
import UpdatesPage from './UpdatesPage';

/**
 * Application routes component that defines all route mappings
 *
 * This component centralizes all routing logic and provides:
 * - Clean separation of routing from app-level concerns
 * - Easy maintenance and modification of routes
 * - Components are self-contained with their own layouts
 * - Single source of truth for all application routes
 *
 * @returns {React.ReactElement} The application routes configuration
 */
function AppRoutes() {
  return (
    <Routes>
      {/* Homepage - special layout */}
      <Route path="/" element={<HomePage />} />

      {/* Legal and informational pages */}
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfUse />} />
      <Route path="/cookies" element={<CookiePolicy />} />
      <Route path="/accessibility" element={<Accessibility />} />
      <Route
        path="/california-privacy"
        element={<CaliforniaDataCollection />}
      />

      {/* Join/signup pages */}
      <Route path="/join-consultant" element={<JoinConsultant />} />
      <Route path="/join-integrator" element={<JoinIntegrator />} />

      {/* Collaboration pages */}
      <Route path="/collaborate" element={<CollaborateWithUs />} />
      <Route path="/lets-collaborate" element={<LetsCollaborate />} />
      <Route path="/discuss-project" element={<DiscussProject />} />
      <Route path="/early-access-program" element={<EarlyAccessProgram />} />
      <Route path="/subscribe" element={<Subscribe />} />

      {/* AWS practices page (linked from the industry Learn More cards) */}
      <Route path="/aws" element={<AwsPage />} />

      {/* Content pages */}
      <Route path="/ebooks" element={<EBooksPage />} />
      <Route
        path="/ebooks/finance-first-cloud-management"
        element={<FinanceFirstCloudManagement />}
      />
      <Route path="/updates" element={<UpdatesPage />} />
      <Route
        path="/updates/rochelle-manns-milestone-circles"
        element={<MilestoneCirclesUpdate />}
      />
      <Route
        path="/updates/amazon-quick-phoenix-user-group"
        element={<PhoenixUserGroupUpdate />}
      />

      {/* Business Outcome pages */}
      <Route
        path="/business-outcome/hcls-modernization"
        element={<BusinessOutcomeHCLS />}
      />
      <Route
        path="/business-outcome/genai-nonprofit"
        element={<GenAINonProfit />}
      />

      {/* Case Study pages */}
      <Route
        path="/case-studies/nonprofit-amazon-connect"
        element={<CaseStudyNonprofitConnect />}
      />
      <Route
        path="/case-studies/hcls-clinical-intelligence"
        element={<CaseStudyMtomicsClinical />}
      />
      <Route
        path="/case-studies/mtomics-clinical-intelligence"
        element={
          <Navigate to="/case-studies/hcls-clinical-intelligence" replace />
        }
      />
      <Route
        path="/case-studies/rising-routes-alliance"
        element={<RisingRoutesCaseStudy />}
      />

      {/* Solution Guide pages */}
      <Route
        path="/solution-guides/hublife-for-nonprofits"
        element={<HubLifeNonprofitsSolutionGuide />}
      />

      {/* Assessment pages */}
      <Route
        path="/assessment/genai-governance"
        element={<GenAIAssessment />}
      />

      {/* Article pages */}
      <Route path="/articles" element={<Navigate to="/updates" replace />} />
      <Route
        path="/articles/rds-sql-server-reinvent-2025"
        element={<RDSSQLServerArticle />}
      />

      {/* Authentication */}
      <Route path="/sign-in" element={<SignIn />} />

      {/* Error pages */}
      <Route path="/server-error" element={<ServerError />} />

      {/* 404 - catch all */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default AppRoutes;
